export default "__VITE_ASSET__CE1xAWJ9__"